var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _g, _g2, _g3, _g4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRooms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 221.334,
    height: 164.92,
    viewBox: "0 0 221.334 164.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ebebeb;}.b{fill:#f0f0f0;}.c{fill:#f5f5f5;}.d{fill:#e0e0e0;}.e,.j,.k,.o,.p{fill:#fff;}.f{fill:#e6e6e6;}.g{fill:currentColor;}.h,.i{fill:#263238;}.h,.o,.q,.t{opacity:0.3;}.j{opacity:0.1;}.k,.l{opacity:0.2;}.m{fill:#a02724;}.n{fill:#b55b52;}.p{opacity:0.4;}.r{opacity:0.5;}.s{fill:#ffc3bd;}.u{fill:#ed847e;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 221.334,
    height: 0.111,
    transform: "translate(0 144.929)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 23.492,
    height: 0.111,
    transform: "translate(175.664 152.052)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 25.967,
    height: 0.111,
    transform: "translate(120.654 150.666)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 8.495,
    height: 0.111,
    transform: "translate(168.302 150.029)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 19.119,
    height: 0.111,
    transform: "translate(44.475 148.688)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6.835,
    height: 0.111,
    transform: "translate(35.174 148.688)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 23.993,
    height: 0.111,
    transform: "translate(58.198 150.556)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M126.208,180.186H40.733a2.528,2.528,0,0,1-2.523-2.528V57.506A2.528,2.528,0,0,1,40.733,55h85.475a2.528,2.528,0,0,1,2.528,2.528V177.659A2.528,2.528,0,0,1,126.208,180.186ZM40.733,55.089a2.417,2.417,0,0,0-2.413,2.417V177.659a2.417,2.417,0,0,0,2.413,2.417h85.475a2.421,2.421,0,0,0,2.417-2.417V57.506a2.421,2.421,0,0,0-2.417-2.417Z",
    transform: "translate(-21.296 -55)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M342.507,180.186H257.028a2.532,2.532,0,0,1-2.528-2.528V57.506A2.532,2.532,0,0,1,257.028,55h85.479a2.528,2.528,0,0,1,2.519,2.506V177.659A2.528,2.528,0,0,1,342.507,180.186Zm-85.479-125.1a2.421,2.421,0,0,0-2.417,2.417V177.659a2.421,2.421,0,0,0,2.417,2.417h85.479a2.421,2.421,0,0,0,2.417-2.417V57.506a2.421,2.421,0,0,0-2.417-2.417Z",
    transform: "translate(-141.841 -55)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.652,
    height: 55.347,
    transform: "translate(122.716 141.185) rotate(180)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 92.27,
    height: 3.687,
    transform: "translate(120.928 144.872) rotate(180)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 91.19,
    height: 55.347,
    transform: "translate(26.874 85.838)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 4.807,
    height: 3.488,
    transform: "translate(123.969 85.838) rotate(180)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 93.536,
    height: 3.488,
    transform: "translate(25.626 82.35)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 83.872,
    height: 19.092,
    rx: 7.78,
    transform: "translate(30.531 90.132)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 83.872,
    height: 19.092,
    rx: 7.78,
    transform: "translate(30.531 114.925)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 41.212,
    height: 2.616,
    rx: 1.308,
    transform: "translate(93.075 92.172) rotate(180)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 41.212,
    height: 2.616,
    rx: 1.308,
    transform: "translate(93.075 116.966) rotate(180)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 14.033,
    height: 2.683,
    transform: "translate(183.924 103.996)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 2.59,
    height: 91.809,
    transform: "translate(175.761 144.93) rotate(180)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 19.725,
    height: 2.683,
    transform: "translate(183.929 106.674) rotate(180)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 14.033,
    height: 2.683,
    transform: "translate(183.924 128.697)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 19.725,
    height: 2.683,
    transform: "translate(183.929 131.379) rotate(180)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 14.033,
    height: 2.683,
    transform: "translate(183.924 54.59)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 19.725,
    height: 2.683,
    transform: "translate(183.929 57.272) rotate(180)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 14.033,
    height: 2.683,
    transform: "translate(183.924 79.291)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 19.725,
    height: 2.683,
    transform: "translate(183.929 81.978) rotate(180)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 2.59,
    height: 91.809,
    transform: "translate(195.487 144.93) rotate(180)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.59,
    height: 91.809,
    transform: "translate(183.924 144.93) rotate(180)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.59,
    height: 91.809,
    transform: "translate(166.793 144.93) rotate(180)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 116.953,
    height: 62.093,
    transform: "translate(155.859 74.652) rotate(180)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 118.237,
    height: 62.093,
    transform: "translate(154.19 74.652) rotate(180)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 52.306,
    height: 109.764,
    transform: "translate(149.949 17.45) rotate(90)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.838 154.898)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 85.829,
    cy: 5.011,
    rx: 85.829,
    ry: 5.011
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.32 65.736)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M231.427,260.508H108.684a1.479,1.479,0,0,1-1.474-1.474h0a1.479,1.479,0,0,1,1.474-1.474H231.427a1.479,1.479,0,0,1,1.474,1.474h0a1.479,1.479,0,0,1-1.474,1.474Z",
    transform: "translate(-104.071 -233.629)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M349.788,260.508H321.054a1.479,1.479,0,0,1-1.474-1.474h0a1.478,1.478,0,0,1,1.474-1.474h28.734a1.479,1.479,0,0,1,1.474,1.474h0A1.478,1.478,0,0,1,349.788,260.508Z",
    transform: "translate(-222.432 -233.629)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 94.399,
    height: 10.274,
    transform: "translate(29.84 30.575)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 94.399,
    height: 10.274,
    transform: "translate(29.84 30.575)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M376.164,329.469h2.824l-.115-65.249H374.96Z",
    transform: "translate(-253.297 -237.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M376.164,329.469h2.824l-.115-65.249H374.96Z",
    transform: "translate(-253.297 -237.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M315.319,329.469H312.49l6.392-65.249H322.8Z",
    transform: "translate(-218.481 -237.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M315.319,329.469H312.49l6.392-65.249H322.8Z",
    transform: "translate(-218.481 -237.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M163.794,329.469h2.824L166.5,264.22H162.59Z",
    transform: "translate(-134.937 -237.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M163.794,329.469h2.824L166.5,264.22H162.59Z",
    transform: "translate(-134.937 -237.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M102.949,329.469H100.12l6.392-65.249h3.913Z",
    transform: "translate(-100.12 -237.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M102.949,329.469H100.12l6.392-65.249h3.913Z",
    transform: "translate(-100.12 -237.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M274.623,241.52h-6.516L265.5,228.78h6.516Z",
    transform: "translate(-192.292 -217.589)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M268.026,224.806H239.757a1.589,1.589,0,0,1-1.6-1.7l1.08-17.9a1.837,1.837,0,0,1,1.806-1.7h28.273a1.594,1.594,0,0,1,1.6,1.7l-1.08,17.9A1.842,1.842,0,0,1,268.026,224.806Z",
    transform: "translate(-177.049 -203.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M267.026,224.806H238.757a1.589,1.589,0,0,1-1.6-1.7l1.08-17.9a1.837,1.837,0,0,1,1.806-1.7h28.273a1.594,1.594,0,0,1,1.6,1.7l-1.08,17.9A1.841,1.841,0,0,1,267.026,224.806Z",
    transform: "translate(-176.492 -203.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M239.865,225.018a.726.726,0,0,1-.527-.221.739.739,0,0,1-.19-.544l1.08-17.9a.952.952,0,0,1,.925-.885h28.273a.708.708,0,0,1,.717.766l-1.08,17.9a.947.947,0,0,1-.925.885Z",
    transform: "translate(-177.604 -204.598)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M268.82,203.5l1.837,6.29,5.454-6.29Z",
    transform: "translate(-194.142 -203.5)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.426 40.729)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M169.542,168.18c.044.341.257.6.483.58s.367-.31.323-.651-.257-.6-.478-.58S169.5,167.848,169.542,168.18Z",
    transform: "translate(-149.914 -158.445)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M170.39,170.15a10.859,10.859,0,0,0,1.532,2.457,1.66,1.66,0,0,1-1.377.292Z",
    transform: "translate(-150.39 -159.906)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M166.715,164.233a.278.278,0,0,1-.1,0,.208.208,0,0,1-.111-.266,1.952,1.952,0,0,1,1.372-1.191.2.2,0,0,1,.23.164.2.2,0,0,1-.164.235,1.509,1.509,0,0,0-1.062.947.212.212,0,0,1-.164.111Z",
    transform: "translate(-148.216 -155.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M146.739,181.07l2.656,2.036,3.625,2.776a3.754,3.754,0,0,0-.354,1.328c-.128,1.018-.257,1.771,2.005,2.395a1.288,1.288,0,0,1,.965,1c.089.6-.279,1.328-2.368,1.687a9.6,9.6,0,0,1-5.9-1c-.885-.443-.885-.974-.513-1.872C147.97,186.865,147.43,183.606,146.739,181.07Z",
    transform: "translate(-137.142 -165.992)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M140,197.766a18.445,18.445,0,0,0,1.257-3.063s6.729-.367,8.951.3,3.6,3.541,3.6,3.541Z",
    transform: "translate(-133.453 -173.533)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M135.642,210.418c-.164.5-.345,1.1-.518,1.66l-.5,1.726c-.31,1.151-.611,2.306-.846,3.457a32.986,32.986,0,0,0-.571,3.409,16.174,16.174,0,0,0-.1,3.174,7.159,7.159,0,0,0,.2,1.328c.027.089.049.186.08.27l.089.239h0a1.123,1.123,0,0,0-.071-.124,2.121,2.121,0,0,0-.146-.186,1.059,1.059,0,0,0-.195-.182c-.089-.062-.1-.053-.084-.031a2.174,2.174,0,0,0,.416.235c.2.089.443.177.686.261.5.168,1.054.323,1.625.474,2.284.575,4.776,1.023,7.207,1.54l-.08,3.068a39.068,39.068,0,0,1-3.913.323,37.63,37.63,0,0,1-3.984-.066,19.136,19.136,0,0,1-2.094-.257c-.363-.066-.739-.142-1.138-.252a6.968,6.968,0,0,1-1.328-.491,4.763,4.763,0,0,1-.885-.553,4.028,4.028,0,0,1-.536-.514,4.154,4.154,0,0,1-.283-.376c-.044-.075-.093-.15-.133-.226l-.058-.106-.305-.624c-.093-.208-.168-.412-.248-.62a12.445,12.445,0,0,1-.6-2.39,26.318,26.318,0,0,1,.367-8.49c.248-1.328.54-2.656.885-3.918.177-.642.363-1.284.562-1.917s.412-1.244.668-1.939Z",
    transform: "translate(-126.28 -181.179)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M130.478,200.249c4.183-1.107,6.667,2.32,5.25,7.968s-1.89,5.861-1.89,5.861l-8.628-1.439C126.272,207.106,126.188,201.378,130.478,200.249Z",
    transform: "translate(-125.21 -176.566)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M162.1,249.188l-.651-.058c-1.85,0-2.169.5-3.307,1.563l-.443,2.328c2.988,1.527,4.59-.15,4.595-.15h2.767l-.974-2.213a2.435,2.435,0,0,0-1.988-1.47Z",
    transform: "translate(-143.318 -203.924)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M144.177,162.567c.753,4.033.987,6.432,3.3,8.234,3.471,2.7,8.251.133,8.721-4.064.421-3.776-.885-9.739-5.055-10.8a5.7,5.7,0,0,0-6.963,6.627Z",
    transform: "translate(-135.722 -151.894)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M146.48,159.09c2.877-.23,2.036-3.262,1.147-3.9a2.664,2.664,0,0,0,.983-4.126c.761-1.988-1.417-4.382-5.237-4.024-2.789.257-3.1,1.731-3.1,1.731s-3.342-.35-4.732,2.408c-1.186,2.364.252,3.625.252,3.625s-2.5.726-1.806,3.984c.735,3.515,3.435,2.7,3.435,2.7s-.606,3.223,3.046,3.267c3.156.04,3.2-2.324,3.2-2.324S147.755,162.056,146.48,159.09Z",
    transform: "translate(-130.035 -147.009)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M157.36,172.135a3.749,3.749,0,0,0,1.771,2.01c1.054.54,1.859-.58,1.673-1.731-.168-1.031-1.067-2.355-2.178-2.417S156.966,171.064,157.36,172.135Z",
    transform: "translate(-143.057 -159.819)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M250.97,386.259l3.935-1.6-2.78-9.451L248.19,376.8Z",
    transform: "translate(-193.751 -274.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M249.54,381.39l3.975-1.461-1.39-4.719L248.19,376.8Z",
    transform: "translate(-193.751 -274.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M256.654,392.37l-4.5,1.563a.3.3,0,0,0-.2.376l1.018,3.639a.757.757,0,0,0,.952.469c1.554-.575,2.182-.885,4.1-1.718a60.642,60.642,0,0,0,5.542-2.656c1.5-.885.6-2.395-.133-2.147-1.731.584-4.568.965-6.007.469A1.191,1.191,0,0,0,256.654,392.37Z",
    transform: "translate(-195.841 -283.477)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M163.8,276.17s29.743,2.656,30.513,11.213c1.549,17.41,3.926,34.2,3.926,34.2l-6.051,2.213s-7.406-19.123-7.308-32.757c-8.579-2.421-31.137,1.133-34.825-5.485-3.258-5.843-.4-10.04-.4-10.04Z",
    transform: "translate(-138.189 -218.627)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M244.558,380.166l7.534-2.545-.328-3.431-8.495,2.736Z",
    transform: "translate(-191.009 -273.624)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M264.794,391.883a5.143,5.143,0,0,1-1.116.226.1.1,0,0,1-.1-.049.1.1,0,0,1,0-.106c.1-.133.965-1.3,1.518-1.284a.385.385,0,0,1,.31.19.545.545,0,0,1,.058.549A1.151,1.151,0,0,1,264.794,391.883Zm-.885,0c.766-.106,1.288-.31,1.408-.562a.345.345,0,0,0-.049-.354.173.173,0,0,0-.151-.1c-.319-.013-.868.558-1.231,1.014Z",
    transform: "translate(-202.32 -282.809)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M263.311,391.338a.089.089,0,0,1-.049,0,.1.1,0,0,1-.075-.058c0-.049-.509-1.169-.243-1.7a.5.5,0,0,1,.35-.266.376.376,0,0,1,.443.164,2.194,2.194,0,0,1-.376,1.824A.1.1,0,0,1,263.311,391.338Zm0-1.815a.3.3,0,0,0-.173.155,2.19,2.19,0,0,0,.181,1.363,2.019,2.019,0,0,0,.261-1.456c-.031-.049-.084-.106-.226-.075Z",
    transform: "translate(-201.93 -282.043)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206.9,393.768l4.205-.2.686-9.929-4.205.2Z",
    transform: "translate(-170.738 -278.891)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M209.775,404.259l-4.763-.151a.3.3,0,0,0-.323.279l-.35,3.758a.757.757,0,0,0,.735.784c1.66.022,2.452-.049,4.546,0a38.476,38.476,0,0,0,5.591,0c1.766-.23,1.5-1.961.726-2.027a11.582,11.582,0,0,1-5.423-2.382,1.173,1.173,0,0,0-.739-.261Z",
    transform: "translate(-169.311 -290.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M218.489,404.886a5.367,5.367,0,0,1-1.124-.186.1.1,0,0,1-.031-.177c.137-.093,1.363-.885,1.877-.655a.376.376,0,0,1,.221.288.544.544,0,0,1-.142.531A1.116,1.116,0,0,1,218.489,404.886Zm-.85-.323c.753.177,1.328.173,1.518,0a.359.359,0,0,0,.08-.354.181.181,0,0,0-.106-.142c-.292-.133-1.009.2-1.527.5Z",
    transform: "translate(-176.528 -290.141)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M217.344,403.431a.1.1,0,0,1-.049,0,.106.106,0,0,1-.049-.084c0-.049-.058-1.271.381-1.669a.478.478,0,0,1,.443-.124.376.376,0,0,1,.35.31c.08.465-.58,1.328-1.009,1.567A.088.088,0,0,1,217.344,403.431Zm.633-1.687a.283.283,0,0,0-.217.08,2.185,2.185,0,0,0-.319,1.328c.376-.3.819-.961.766-1.266,0-.058-.044-.124-.186-.146Z",
    transform: "translate(-176.504 -288.868)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M207.971,383.839l4.21-.2-.4,5.679-4.192,0Z",
    transform: "translate(-171.123 -278.891)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M143.275,275.228s32.049,4.9,31.54,12.28c-.916,13.28-5.37,39.234-5.37,39.234l-6.312.089s-1.492-26.622.885-36.325c-7.884,0-30.124-.274-33.156-4.325-3.355-4.475.093-11.509.093-11.509Z",
    transform: "translate(-127.542 -218.158)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M203.467,388.387l7.64-.12.376-4.037-8.384.328Z",
    transform: "translate(-168.621 -279.22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M149.563,199.024c-2.581-.5-14.218-.359-14.218-.359a4.648,4.648,0,0,0-4.745,4.121c-.407,3.59,1.872,11.611,1.952,15.7.1,5.024-.863,7.061-.961,13.825l22.209,1.018c0-13.6-.593-24.865-1.129-30.265C152.48,201.166,152.143,199.524,149.563,199.024Z",
    transform: "translate(-128.186 -175.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M149.563,199.024c-2.581-.5-14.218-.359-14.218-.359a4.648,4.648,0,0,0-4.745,4.121c-.407,3.59,1.872,11.611,1.952,15.7.1,5.024-.863,7.061-.961,13.825l22.209,1.018c0-13.6-.593-24.865-1.129-30.265C152.48,201.166,152.143,199.524,149.563,199.024Z",
    transform: "translate(-128.186 -175.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M172.751,209.18c.695,2.39,1.394,4.847,2.116,7.246s1.461,4.812,2.293,7.083c.2.58.443,1.12.637,1.678l.341.784.044.1v.075h0v-.031a1.673,1.673,0,0,0-.283-.372c-.151-.146-.208-.159-.221-.159a1.1,1.1,0,0,0,.336.208,5.5,5.5,0,0,0,.668.27c.5.173,1.062.328,1.633.482,2.315.589,4.843,1.04,7.3,1.567l-.08,3.068a37.622,37.622,0,0,1-3.984.323,35.484,35.484,0,0,1-4.046-.075,19.035,19.035,0,0,1-2.134-.274c-.372-.071-.757-.159-1.173-.279a6.507,6.507,0,0,1-1.417-.584,4.59,4.59,0,0,1-.974-.748,3.651,3.651,0,0,1-.567-.761l-.151-.279-.5-.947c-.292-.62-.611-1.244-.885-1.859-.544-1.244-1.023-2.475-1.5-3.71s-.885-2.47-1.3-3.71c-.819-2.492-1.558-4.958-2.213-7.525Z",
    transform: "translate(-148.334 -181.659)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M164.423,201.677c3.037-3.1,6.919-1.408,8.588,4.188s1.368,6,1.368,6l-8.158,3.165C164.294,209.7,161.315,204.834,164.423,201.677Z",
    transform: "translate(-146.313 -176.622)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M213.326,249.188l-.651-.058c-1.85,0-2.165.5-3.3,1.563l-.443,2.328c2.988,1.527,4.59-.15,4.59-.15h2.771l-.978-2.213A2.426,2.426,0,0,0,213.326,249.188Z",
    transform: "translate(-171.87 -203.924)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 30.624,
    height: 4.081,
    rx: 2.041,
    transform: "translate(33.873 73.966) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M133.807,359.534H132.55L134,314.09h1.74Z",
    transform: "translate(-129.301 -240.128)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M133.807,359.534H132.55L134,314.09h1.74Z",
    transform: "translate(-129.301 -240.128)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M159.086,359.534h1.257L158.9,314.09h-1.74Z",
    transform: "translate(-143.017 -240.128)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M159.086,359.534h1.257L158.9,314.09h-1.74Z",
    transform: "translate(-143.017 -240.128)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M171.187,359.534H169.93l1.448-45.444h1.74Z",
    transform: "translate(-150.134 -240.128)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M171.187,359.534H169.93l1.448-45.444h1.74Z",
    transform: "translate(-150.134 -240.128)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M196.466,359.534h1.257L196.28,314.09h-1.74Z",
    transform: "translate(-163.85 -240.128)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M196.466,359.534h1.257L196.28,314.09h-1.74Z",
    transform: "translate(-163.85 -240.128)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "q",
    transform: "translate(4.635 73.962)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M135.742,314.09h1.74l-.084,1.93H135.68Z",
    transform: "translate(-135.68 -314.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M158.957,316.02H157.24l-.08-1.93H158.9Z",
    transform: "translate(-147.651 -314.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M174.857,314.09l-.08,1.93H173.06l.062-1.93Z",
    transform: "translate(-156.513 -314.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M196.342,316.02H194.62l-.08-1.93h1.74Z",
    transform: "translate(-168.485 -314.09)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.629 5.086)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M294.664,121.356h-70.9a3.984,3.984,0,0,1-4.015-4.272l2.7-44.873a4.613,4.613,0,0,1,4.533-4.272h70.884a3.984,3.984,0,0,1,4.015,4.272L299.175,117.1A4.608,4.608,0,0,1,294.664,121.356Z",
    transform: "translate(-219.095 -67.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M250.26,167.18l6.538,22.368,19.4-22.368Z",
    transform: "translate(-236.107 -122.608)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M328.32,110.121H288.586a2.235,2.235,0,0,1-2.253-2.395l1.518-25.152a2.585,2.585,0,0,1,2.541-2.395h39.734a2.213,2.213,0,0,1,2.253,2.395l-1.518,25.152A2.585,2.585,0,0,1,328.32,110.121Z",
    transform: "translate(-256.208 -74.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M280.3,134.632H240.562a2.235,2.235,0,0,1-2.249-2.395l1.518-25.152a2.585,2.585,0,0,1,2.536-2.395h39.738a2.213,2.213,0,0,1,2.249,2.395l-1.518,25.152a2.585,2.585,0,0,1-2.536,2.395Z",
    transform: "translate(-229.445 -87.779)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "r",
    transform: "translate(8.225 3.218)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M239.233,75.088a1.363,1.363,0,0,1-1.27,1.328,1.151,1.151,0,0,1-1.08-1.328,1.372,1.372,0,0,1,1.27-1.328,1.151,1.151,0,0,1,1.08,1.328Z",
    transform: "translate(-236.869 -73.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M249.017,75.088a1.368,1.368,0,0,1-1.27,1.328,1.151,1.151,0,0,1-1.085-1.328,1.372,1.372,0,0,1,1.27-1.328,1.155,1.155,0,0,1,1.085,1.328Z",
    transform: "translate(-242.319 -73.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M258.883,75.088a1.363,1.363,0,0,1-1.27,1.328,1.151,1.151,0,0,1-1.08-1.328,1.372,1.372,0,0,1,1.27-1.328,1.151,1.151,0,0,1,1.08,1.328Z",
    transform: "translate(-247.82 -73.76)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M293.307,120.132H222.423a4.1,4.1,0,0,1-4.126-4.391l2.709-44.873a4.719,4.719,0,0,1,4.639-4.378h70.867a4.1,4.1,0,0,1,4.126,4.391l-2.7,44.873A4.723,4.723,0,0,1,293.307,120.132ZM225.646,66.716a4.493,4.493,0,0,0-4.427,4.17l-2.709,44.873a3.873,3.873,0,0,0,3.9,4.157h70.893a4.5,4.5,0,0,0,4.427-4.17l2.7-44.873a3.882,3.882,0,0,0-3.926-4.157Z",
    transform: "translate(-218.287 -66.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M277.571,122.967c-.3.637-.575,1.182-.885,1.771s-.62,1.12-.938,1.673c-.651,1.1-1.328,2.213-2.054,3.249q-.549.8-1.124,1.58c-.4.513-.784,1.036-1.213,1.536a31.09,31.09,0,0,1-2.7,2.939c-.243.239-.509.443-.766.695a8.6,8.6,0,0,1-.806.668l-.85.642-.261.181a3.539,3.539,0,0,1-.359.2,3.633,3.633,0,0,1-3.776-.39,3.78,3.78,0,0,1-.571-.558l-.12-.159-.058-.08-.022-.035-.08-.142-.319-.575c-.1-.186-.164-.363-.243-.544a14.342,14.342,0,0,1-.682-2.058,27.538,27.538,0,0,1-.646-3.891,33.586,33.586,0,0,1-.168-3.842,1.527,1.527,0,0,1,2.992-.39v.053a56.418,56.418,0,0,0,2.174,6.64,10.549,10.549,0,0,0,.686,1.328c.058.089.115.195.173.27l.168.2.04.053h0l-.022-.035-.049-.066a1.381,1.381,0,0,0-.239-.243,1.576,1.576,0,0,0-.6-.3,1.616,1.616,0,0,0-.668,0,1.541,1.541,0,0,0-.332.111c-.058,0-.106.058-.159.084s-.133.093-.075.044l.553-.54c.186-.168.367-.372.549-.567s.367-.385.544-.593a46.455,46.455,0,0,0,3.975-5.551c.606-.987,1.2-1.992,1.771-3.01l.854-1.532.81-1.5.044-.08a3.054,3.054,0,0,1,5.449,2.749Z",
    transform: "translate(-240.935 -95.557)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M257.156,129.893,255,128.658l2.32-2.368a13.241,13.241,0,0,1,1.881,1.7,1.257,1.257,0,0,1-.354,1.988h0A1.828,1.828,0,0,1,257.156,129.893Z",
    transform: "translate(-238.748 -99.818)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M253.512,124.684l1.173-.837a.717.717,0,0,1,1,.151l.642.854L254,127.22l-.73-1.664a.717.717,0,0,1,.239-.872Z",
    transform: "translate(-237.752 -98.381)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M288.206,120.491a3.289,3.289,0,0,1,2.559-2.28,20.048,20.048,0,0,1,2.607-.4,69.653,69.653,0,0,1,7.919.142c1.381.093,2.793.288,3.918.474h.04a2.28,2.28,0,0,1,1.877,2.616c-.553,3.2-2.178,8.756-2.355,14-.235,6.888-.128,10.854-.248,12.514l-17.729-.341C285.559,130.385,287.095,124.3,288.206,120.491Z",
    transform: "translate(-256.213 -95.064)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M303.974,117.994h-.058c-1.186-.195-2.656-.4-4.13-.5L299,117.45c-.775,3.2-5.392,8.6-6.791,16.768-.54-6.83-.956-13.971-.164-16.755a35.239,35.239,0,0,0-3.745.314,3.811,3.811,0,0,0-2.806,2.612c-1.089,3.2-3.17,10.385-1.89,28.039h19.7c.128-1.771-.332-5.489.381-11.213.686-5.542,1.673-13.085,2.253-16.454A2.408,2.408,0,0,0,303.974,117.994Z",
    transform: "translate(-254.465 -94.892)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M302.3,169.721a.115.115,0,0,1-.12-.106,78.877,78.877,0,0,1,.372-12.2.115.115,0,0,1,.128-.1.12.12,0,0,1,.106.128,79.49,79.49,0,0,0-.372,12.156.115.115,0,0,1-.106.128Z",
    transform: "translate(-264.973 -117.106)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M328.072,131.117c-.73,3.311-.341,7.9.443,12.08.58-4.7,1.372-10.792,1.952-14.564C329.657,128.094,328.652,128.474,328.072,131.117Z",
    transform: "translate(-279.258 -101.007)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M302.962,106.856a2.842,2.842,0,0,0,2.532-3.488,9.956,9.956,0,0,0-.19-1.164l2.868-2.346,2.112-1.718c-.575,2.541-1.208,7.176.527,8.906,0,0-1.417,2.324-5.356,2.041C302.125,108.848,302.962,106.856,302.962,106.856Z",
    transform: "translate(-265.427 -84.129)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M310.167,121.55l-.637.6,2.036.766-.266-.775Z",
    transform: "translate(-269.14 -97.177)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M312.528,121.245s-.8-2.023-1.558-2.452a8.411,8.411,0,0,0,3.944-2.182l1.208.482S316.5,119.439,312.528,121.245Z",
    transform: "translate(-269.942 -94.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M306.354,121.19l.478.761-2.143.186.429-.677Z",
    transform: "translate(-266.442 -96.976)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M301.42,120.774a9.645,9.645,0,0,1,2.74-2.036c-1.164-.345-1.235-1.948-1.235-1.948l-1.129.217S299.725,119.021,301.42,120.774Z",
    transform: "translate(-264.248 -94.524)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M308.37,104.362a10.18,10.18,0,0,1,.19,1.169,3.6,3.6,0,0,0,2.656-2.413,4.968,4.968,0,0,0,.031-1.1Z",
    transform: "translate(-268.493 -86.292)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M299.7,80.629c-1.027,1.262-.93,5.826,1.244,5.879S301.572,78.327,299.7,80.629Z",
    transform: "translate(-263.311 -74.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M309.185,82.309c-.217,3.457-.173,5.489-1.917,7.277a4.559,4.559,0,0,1-7.689-2.3c-.73-3.1-.252-8.229,3.125-9.632a4.661,4.661,0,0,1,6.481,4.652Z",
    transform: "translate(-263.429 -72.504)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M316.743,81.048c-2.174,2.156.651,3.736-.443,4.9,2.05,1.071,1.3,1.859,1.3,1.859a2.691,2.691,0,0,0,0,1.824c2.311-.593,6.6-8.269,1.917-9.447C316.712,81.428,316.743,81.048,316.743,81.048Z",
    transform: "translate(-272.687 -74.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M307.774,79.032c-2.058.319-4.648-.664-6.255-1.5s-1.841.739-1.248,1.217a2.026,2.026,0,0,1-2.014-2.6c.3-1.66,2.47-3.231,5.564-1.828,2.191.992,4.891-.314,5.945.832S309.147,78.815,307.774,79.032Z",
    transform: "translate(-262.829 -70.555)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M323,77.3c1.381-.181,1.439-1.054,1.054-2.581,1.492,2.12.885,2.771,0,3.285C323.066,77.673,323,77.3,323,77.3Z",
    transform: "translate(-276.647 -71.077)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M320.44,92.345a3.161,3.161,0,0,1-1.509,1.545c-.854.385-1.288-.4-1.058-1.328.208-.837.885-2.041,1.771-2.032S320.826,91.491,320.44,92.345Z",
    transform: "translate(-273.755 -79.888)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M308.646,90.359c0,.279-.151.509-.332.513s-.314-.226-.314-.513.151-.509.332-.509S308.646,90.076,308.646,90.359Z",
    transform: "translate(-268.287 -79.509)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M301.464,90.425c0,.283-.151.509-.336.514s-.332-.226-.328-.509.146-.509.332-.509S301.464,90.146,301.464,90.425Z",
    transform: "translate(-264.274 -79.548)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M303.328,91.28A10.181,10.181,0,0,1,302,93.7a1.616,1.616,0,0,0,1.328.243Z",
    transform: "translate(-264.943 -80.306)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M307.007,97.654a2.333,2.333,0,0,0,1.625-.943.082.082,0,0,0-.137-.089,2.258,2.258,0,0,1-1.815.885.082.082,0,1,0,0,.164A2.061,2.061,0,0,1,307.007,97.654Z",
    transform: "translate(-267.507 -83.263)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M311.207,87.294a.124.124,0,0,0,.075-.031.159.159,0,0,0,.031-.23,1.629,1.629,0,0,0-1.328-.673.159.159,0,0,0-.146.177.173.173,0,0,0,.182.155,1.266,1.266,0,0,1,1.049.54A.164.164,0,0,0,311.207,87.294Z",
    transform: "translate(-269.311 -77.564)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M299.157,87.3a.164.164,0,0,0,.124-.089,1.328,1.328,0,0,1,.934-.761.155.155,0,0,0,.137-.186.173.173,0,0,0-.186-.142h0a1.656,1.656,0,0,0-1.186.938.168.168,0,0,0,.075.221.2.2,0,0,0,.1.018Z",
    transform: "translate(-263.251 -77.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M326.4,120.951c.54,1.138.992,2.213,1.434,3.32s.837,2.235,1.231,3.364a56.5,56.5,0,0,1,1.868,7.03c.1.615.217,1.217.292,1.85l.058.469.031.235v.283a7.17,7.17,0,0,1,0,1.377,6.2,6.2,0,0,1-1,2.8,6.281,6.281,0,0,1-2.01,1.881,8.412,8.412,0,0,1-2.134.885,11.4,11.4,0,0,1-2.036.363,14.563,14.563,0,0,1-3.891-.155,1.523,1.523,0,0,1-.08-2.988l.159-.035c.443-.1,1.023-.226,1.518-.359s1-.288,1.47-.443a6.551,6.551,0,0,0,2.235-1.239,1.469,1.469,0,0,0,.385-.584,1.2,1.2,0,0,0,0-.474,2.98,2.98,0,0,0-.066-.354l-.159-.722c-.1-.5-.248-1.027-.381-1.54-.274-1.04-.584-2.081-.938-3.125s-.717-2.085-1.1-3.125-.792-2.081-1.2-3.1-.845-2.089-1.257-3.059v-.044a3.051,3.051,0,1,1,5.569-2.5Z",
    transform: "translate(-274.4 -95.847)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M316.222,172.576l-1.952.938,3.373,1.2s2.249-.717,1.16-1.965l-.606-.19A2.147,2.147,0,0,0,316.222,172.576Z",
    transform: "translate(-271.781 -125.48)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M313.841,177.382l1.483.283a1.036,1.036,0,0,0,1.089-.509l.54-.969L313.58,175l-.443.925a1.027,1.027,0,0,0,.7,1.456Z",
    transform: "translate(-271.092 -126.966)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRooms);
export default __webpack_public_path__ + "static/media/rooms.45f9269a.svg";
export { ForwardRef as ReactComponent };